import images from 'assets/Images';
import styles from './SuccessPage.module.scss'

const SuccessPage = () => {
	return (
		<>
			<img src={images.success} alt='success'/>
			<h3 className={styles.success}>Payment Successful</h3>
		</>
	);
};

export default SuccessPage;
